// Mirrors CPHub.Data.Models.StatusDisplayTargetType. A prescription's subStatus is a
// bare id whose list depends on its status, and the two sub-status lists have
// overlapping ids, so the target list is stated rather than inferred from the id.
export enum StatusDisplayTargetType {
    Status = 0,
    OnHoldSubStatus = 1,
    DiscontinuedSubStatus = 2
}

export const StatusDisplayTargetTypeLabels: Record<StatusDisplayTargetType, string> = {
    [StatusDisplayTargetType.Status]: 'Status',
    [StatusDisplayTargetType.OnHoldSubStatus]: 'On Hold',
    [StatusDisplayTargetType.DiscontinuedSubStatus]: 'Discontinued'
};

// One row of the maintenance grid, as returned by GET /api/program/{id}/status-display.
export interface PrescriptionStatusDisplayEntry {
    targetType: StatusDisplayTargetType;
    targetId: number;
    internalName: string;
    // False for a sub-status that has been deactivated but still carries a mapping. The
    // resolver ignores Active, so the mapping still drives display text; it is listed here
    // so it can be seen and cleared.
    isActive: boolean;
    globalDisplayName: string | null;
    programDisplayName: string | null;
    // Program override, else global default, else internalName. Empty for an unmapped
    // discontinued sub-status, which the portal shows nothing for.
    effectiveDisplayName: string;
}

// Statuses whose text the ProviderWeb grids replace with a workflow stage in the Substatus
// column. The status word itself is still the configured one, so these stay editable - the
// note exists so an administrator understands why an extra word appears alongside it.
export const StageAnnotatedStatusCodes: ReadonlySet<number> = new Set([0, 1, 2, 10]);
